<script>

import config from '../../common/genericPanelConf';
import Service from '../../services/stock-management';
import CommonService from '../../services/common';
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import {FilterMatchMode} from 'primevue/api';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable, ResponsiveButton
    },
    data(){
        return{
            configuration: {},
            filters: {
                referenceDate: new Date()
            }
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        load(){
            let filters = [
                {
                    operator: 'eq',
                    value: Utils.formatDateForAPI(this.filters.referenceDate),
                    property: 'ReferenceDate'
                }
            ]
            this.$refs.dailyPipeGrid.filterFromView(filters, false);
        },
        onDialogEditSave(){

        },
        // onDialogEditSave(newItem, oldItem){
        //     this.$store.dispatch("generic/setLoading", true);
        //     // UPDATE
        //     CommonService.updateItem(this.configuration.api, newItem, response => {
        //         this.disabled = false;
        //         this.$store.dispatch("generic/setLoading", false);
        //         if(response.success){
        //             this.$refs.dailyPipeGrid.hideDialogEdit();
        //             this.load();
        //             this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
        //         }else{
        //             this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        //         }
        //     }, this.configuration.idColumn)
        // },
        // reimport(){
        //     this.$confirm.require({
        //         message:  this.$t('StockManagementDailyPipe.reimportMessage'),
        //         icon: 'pi pi-exclamation-triangle',
        //         acceptLabel: this.$t('yes'),
        //         rejectLabel: this.$t('no'),
        //         accept: () => {
        //             Service.dailyPipeCreateNewDay(response => {
        //                 if(response.success){
        //                     this.$toast.add({detail: this.$t('StockManagementDailyPipe.reimportSuccess'), life:3000, severity:'success'});
        //                     this.load();
        //                 }
        //                 else{
        //                     this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        //                 }
        //             });
        //         },
        //         reject: () => {
                    
        //         }
        //     });
        // }
    },
    computed: {
        conf(){
            return config;
        },
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    }
}
</script>



<template>
    <div class="grid">
        <div class="col-12 lg:col-2">
            <label for="referenceDate">{{$t('StockManagementDailyPipe.referenceDate')}}</label>
            <Calendar
                :class="{'p-inputtext-sm w-full': true}"
                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                :dateFormat="constants.DATE_FORMAT_POINT"
                :showTime="false"
                v-model="filters.referenceDate"
                :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
        </div>
        <div class="col-12 lg:col-7">
                <div class="p-3">
                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="mx-1 my-1" @click="load"/>   
                    <!-- <ResponsiveButton :label="$t('btn.reimport')" icon="pi pi-download" class="mx-1 my-1" @click="reimport" :disabled="!uiPermissions('stockManagementDailyPipeCreateNewDayButton').isEnabled || !utils.isToday(filters.referenceDate)"/>    -->
                </div>
            </div>
        <div class="col-12" style="height: calc(100vh - 210px)">
            <GenericDataTable ref="dailyPipeGrid" :configuration="configuration" :category="category" :name="name" :onDialogEditSave="onDialogEditSave" />
        </div>
    </div>
</template>